import { render, staticRenderFns } from "./aria-hidden.vue?vue&type=template&id=fb333ef6&"
import script from "./aria-hidden.vue?vue&type=script&lang=js&"
export * from "./aria-hidden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports